import React from 'react';
import { Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import LegalLayout from './LegalLayout';

const Terms = () => (
  <LegalLayout title="Terms of Service" updated="7 July 2026">
    <p>
      These terms govern your use of Budget Clues ("the Service"), a personal budgeting and
      money-insights application. By creating an account or using the Service you agree to these terms.
    </p>

    <h2>1. Your account</h2>
    <p>
      You are responsible for keeping your sign-in credentials secure and for all activity under your
      account. You may sign in with an email and password or through a third-party provider such as
      Google or Microsoft. You must provide accurate information and be legally able to enter into
      this agreement.
    </p>

    <h2>2. The Service</h2>
    <p>
      Budget Clues lets you record, import and categorize financial transactions, connect bank
      accounts through our data partner Akahu, set budgets, and view insights derived from your data.
      The Service presents information to help you understand your finances; it is not financial
      advice. Decisions you make based on the Service are your own.
    </p>

    <h2>3. Bank connections</h2>
    <p>
      Connecting a bank account is optional and handled through Akahu's consent flow. We never see or
      store your bank login credentials. You can disconnect a bank at any time from Settings, which
      revokes our access.
    </p>

    <h2>4. Your data</h2>
    <p>
      Your financial data belongs to you. We use it only to operate the Service as described in our{' '}
      <Link component={RouterLink} to="/privacy">Privacy Policy</Link>. You can export your data and
      you can delete your account, including all associated data, from Settings at any time.
    </p>

    <h2>5. Acceptable use</h2>
    <ul>
      <li>Don't attempt to access other users' data or probe, disrupt or overload the Service.</li>
      <li>Don't use the Service for unlawful purposes.</li>
      <li>Don't resell or redistribute the Service without our written permission.</li>
    </ul>

    <h2>6. Availability and changes</h2>
    <p>
      We work to keep the Service available and your data safe, but the Service is provided "as is"
      without warranties of any kind. We may change or discontinue features, and we may update these
      terms. If we make material changes we will note the new date at the top of this page.
    </p>

    <h2>7. Liability</h2>
    <p>
      To the maximum extent permitted by law, Budget Clues is not liable for indirect or consequential
      loss arising from your use of the Service, including decisions made in reliance on the insights
      it presents.
    </p>

    <h2>8. Contact</h2>
    <p>
      Questions about these terms? Contact us at{' '}
      <a href="mailto:support@budgetclues.app">support@budgetclues.app</a>.
    </p>
  </LegalLayout>
);

export default Terms;
